import {
  applyMiddleware,
  combineReducers,
  legacy_createStore,
  compose,
} from "redux";

import { thunk } from "redux-thunk";
import { LoginReducer, Sidebar_Reducer } from "./Reducer/LoginReducer";

const RootReducer = combineReducers({
  LoginReducer,
  Sidebar_Reducer,
});
const InitialState = {
  LoginReducer: {
    accTkn: localStorage.getItem("accTkn") || "",
    UserDet: JSON.parse(localStorage.getItem("UserDt")) || "",
  },
  Sidebar_Reducer: {
    sidebar: false,
  },
};

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export const store = legacy_createStore(
  RootReducer,
  InitialState,
  composeEnhancers(applyMiddleware(thunk))
);
